import React from 'react';
import Container from '../../../../../Common/Container/Container';
import * as classes from './HeroSection.module.scss';
import ContactForm from '../../../../../Common/ContactForm/ContactForm';
import { GetInTouchHeroSectionProps } from '../../../../../Sections/GetInTouch/HeroSection/HeroSection';
import { IExternalLink } from '../../../../../../interfaces/professional/Professional';
import GlobeIcon from '../../../../../../assets/icons/inline/globe-black.inline.svg';
import MailIcon from '../../../../../../assets/icons/inline/sms-black.inline.svg';
import PhoneIcon from '../../../../../../assets/icons/inline/phone-black.inline.svg';
import WorkingHours from '../../../../../Common/WorkingHours/WorkingHours';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import circleDecorator from '../../../../../../assets/images/contacts-decorator-circle.svg';
import dropDecorator from '../../../../../../assets/images/contacts-decorator-drop.svg';
import { FormSectionProps } from '../../../../../Sections/GetInTouch/FormSection/FormSection';

const HeroSection = ({
  externalLinks,
  phone,
  email,
  openingTime,
  professionalID,
  template,
}: GetInTouchHeroSectionProps & FormSectionProps) => {
  const { t } = useTranslation();

  const externalLinksMapper = (item: IExternalLink, index: number) => (
    <li key={index}>
      <GlobeIcon />
      <a href={item.url}>{item.linkDescription}</a>
    </li>
  );

  return (
    <section className={classes.wrapper} data-aos='fade-in'>
      <div className={classes.contactsWrapper}>
        <img src={circleDecorator} className={classes.circleDecorator} alt='' />
        <img src={dropDecorator} className={classes.dropDecorator} alt='' />
        <Container>
          <h1 className={classes.title}>{t('getInTouch.h1Title')}</h1>
          <ul className={classes.contactsList}>
            <li>
              <PhoneIcon />
              <a href={`tel:${phone}`}>{phone}</a>
            </li>
            <li>
              <MailIcon />
              <a href={`mailto:${email}`}>{email}</a>
            </li>
            {externalLinks.map(externalLinksMapper)}
          </ul>
        </Container>
      </div>
      <div className={classes.workingHoursWrapper}>
        <WorkingHours {...openingTime} isTransparentBg />
      </div>
      <div className={classes.formWrapper}>
        <Container className={classes.container}>
          <div className={classes.title}>{t('getInTouch.formSection.titleText')}</div>
          <ContactForm template={template} professionalID={professionalID} />
        </Container>
      </div>
    </section>
  );
};

export default HeroSection;
